export default {
  default: [
    {
      path: "/contact",
      name: "contact.index",
      component: () => import("@/modules/contact/views/ContactView.vue")
    }
  ]
};
